/* eslint-disable react/prop-types */
import React from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import Powered from '../img/Hero Section/Powered-by1.png';
import BulbImg from '../img/Hero Section/Bulb.svg';
import './Hero.scss';
import Subtract from '../img/Hero Section/Subtract.png';
import Sun from '../img/Hero Section/Sun.png';
import WhiteListBanner from '../banners/WhiteListBanner';
import LotteryBanner from '../banners/LotteryBanner';
import PurchaseBanner from '../banners/PurchaseBanner';
import { getStateFromUrl } from '../utils/helper';

/* eslint-disable react/jsx-props-no-spreading */

export default function Hero({ darkTheme, lightTheme, ...props }) {
    const state = getStateFromUrl();
    console.log(state)

    return (
        <div className={`hero-container ${props.navState ? 'spillited-bg-img' : 'not-spillited-bg-img'}`} id="Home">
            <Container className="w-100 h-100">
                <Row className={`${state === 'lottery' ? 'banner-height' : state === 'whitelist' ? 'banner-height' : state === 'purchase' ? 'banner-height' : 'hero-height'}`}>
                    <Col xs={{ span: 12, order: 'last' }} md={{ span: 6, order: 'first' }} style={{ padding: '0'}}>
                        <div className="d-flex center-fix align-items-center w-100 h-100"> 
                            <div className="content">
                                <div className="hero">
                                    <h1 className="hero__heading raise-capital-animation animate__animated animate__fadeInUp">
                                        Raise Capital. 
                                    </h1>
                                    <p className="hero__heading build-fast-animation animate__animated animate__fadeInLeft">
                                        Build Fast.
                                    </p>
                                    
                                    
                                    <h5 className="hero__sub">
                                        <span className="text-success solrazr-leading-animation animate__animated animate__fadeIn">SolRazr</span><span className="solrazr-leading-animation animate__animated animate__fadeIn"> is the leading</span>
                                        <span className="text-danger solrazr-leading-animation animate__animated animate__fadeIn"> Solana</span><span className="solrazr-leading-animation animate__animated animate__fadeIn"> launchpad</span>
                                    </h5>
                                </div>

                                <div>
                                    <div className="line6 solrazr-logo-animation animate__animated animate__fadeIn" />
                                    <div className="powered-text solrazr-logo-animation animate__animated animate__fadeIn" />
                                    <div className="poweredby solrazr-logo-animation animate__animated animate__fadeIn" />
                                    {/* <img
                                        src={Powered}
                                        alt="powered"
                                        className="mt-4 mb-4 mobile-view"
                                    /> */}
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col
                        xs={{ span: 12, order: 'first' }}
                        md={{ span: 6, order: 'last' }}
                        className="d-flex align-items-center">
                        <div className="img-content illustration-img-animation">
                            <img src={BulbImg} alt="video" className="video mt-md-0 mb-5 mb-md-0" />
                        </div>
                    </Col>
                </Row>
            </Container>
            <div className="floating-toggle-button">
                <Button className="toggle-night" onClick={darkTheme}>
                    {/* <img src={Subtract} alt="Subtract" /> */}
                </Button>
                <Button className="toggle-day" onClick={lightTheme}>
                    {/* <img className="yellow-in-dark" src={Sun} alt="Sun" /> */}
                </Button>
            </div>
        </div>
    );
}
